// extracted by mini-css-extract-plugin
module.exports = {"container":"add-instruction-box__container___3aXWg","title":"add-instruction-box__title___346R1","linkButton":"add-instruction-box__linkButton___olPIB"};